var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "isApplicable"
    }
  }, [_vm._v("Choose applicable charge:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.insuranceapplicablecharge),
      expression: "insuranceapplicablecharge"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "value": "FOV"
    },
    domProps: {
      "checked": _vm._q(_vm.insuranceapplicablecharge, "FOV")
    },
    on: {
      "click": _vm.clearValidation,
      "__c": function($event) {
        _vm.insuranceapplicablecharge = "FOV"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    staticStyle: {
      "font-size": "0.99em"
    }
  }, [_vm._v("FOV")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.insuranceapplicablecharge),
      expression: "insuranceapplicablecharge"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "value": "ROV"
    },
    domProps: {
      "checked": _vm._q(_vm.insuranceapplicablecharge, "ROV")
    },
    on: {
      "click": _vm.clearValidation,
      "__c": function($event) {
        _vm.insuranceapplicablecharge = "ROV"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    staticStyle: {
      "font-size": "0.99em"
    }
  }, [_vm._v("ROV")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "0px 0px 0px 30px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.insuranceapplicablecharge),
      expression: "insuranceapplicablecharge"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "value": "None"
    },
    domProps: {
      "checked": _vm._q(_vm.insuranceapplicablecharge, "None")
    },
    on: {
      "click": _vm.clearValidation,
      "__c": function($event) {
        _vm.insuranceapplicablecharge = "None"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    staticStyle: {
      "font-size": "0.99em"
    }
  }, [_vm._v("None")])])])])]), _vm._v(" "), (_vm.insuranceapplicablecharge != 'None') ? _c('div', [_c('label', [_vm._v("\n    Choose " + _vm._s(_vm.insuranceapplicablecharge) + " Charge Type"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.insuranceChargeType),
      expression: "insuranceChargeType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "name": "insuranceChargeType",
      "value": "FOV_CHARGE"
    },
    domProps: {
      "checked": _vm._q(_vm.insuranceChargeType, "FOV_CHARGE")
    },
    on: {
      "click": function($event) {
        _vm.selectedType('FOV_CHARGE')
      },
      "__c": function($event) {
        _vm.insuranceChargeType = "FOV_CHARGE"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "insuranceChargeType"
    }
  }, [_vm._v(_vm._s(_vm.insuranceapplicablecharge) + " Charges = Invoice Value x " + _vm._s(_vm.insuranceapplicablecharge) + "%")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.insuranceChargeType),
      expression: "insuranceChargeType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "name": "insuranceChargeType",
      "value": "FLAT_CHARGE"
    },
    domProps: {
      "checked": _vm._q(_vm.insuranceChargeType, "FLAT_CHARGE")
    },
    on: {
      "click": function($event) {
        _vm.selectedType('FLAT_CHARGE')
      },
      "__c": function($event) {
        _vm.insuranceChargeType = "FLAT_CHARGE"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "insuranceChargeType"
    }
  }, [_vm._v("Flat Charges Per Shipment")]), _vm._v("   \n        ")])])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.insurancechargetypeflag == 1),
      expression: "insurancechargetypeflag == 1"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please Select Insurance Charge Type")]), _vm._v(" "), (_vm.insuranceChargeType == 'FOV_CHARGE') ? _c('div', [_c('div', {
    staticClass: "form-group row"
  }, [_c('legend', [_vm._v(_vm._s(_vm.insuranceapplicablecharge) + " % Type")]), _vm._v(" "), _c('div', {
    staticClass: "box",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group "
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.fovType),
      expression: "fovType"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "name": "fovType",
      "value": "FLAT"
    },
    domProps: {
      "checked": _vm._q(_vm.fovType, "FLAT")
    },
    on: {
      "__c": function($event) {
        _vm.fovType = "FLAT"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Commercial"
    }
  }, [_vm._v("Flat Rate")])])])]), _vm._v(" "), (_vm.fovType == 'FLAT') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v(_vm._s(_vm.insuranceapplicablecharge) + " Rate (%)")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-percent'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.fovRate),
      expression: "fovRate"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('FOV Rate')
    },
    attrs: {
      "type": "number",
      "name": "FOV Rate",
      "id": "fovRate",
      "placeholder": "Rate (%)"
    },
    domProps: {
      "value": (_vm.fovRate)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fovRate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('FOV Rate')),
      expression: "errors.has('FOV Rate')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.insuranceapplicablecharge) + " Rate (%) is required")])], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fovType),
      expression: "fovType"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "name": "fovType",
      "value": "SLAB"
    },
    domProps: {
      "checked": _vm._q(_vm.fovType, "SLAB")
    },
    on: {
      "__c": function($event) {
        _vm.fovType = "SLAB"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Commercial"
    }
  }, [_vm._v("Slab Based")]), _vm._v("   \n              ")])])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('fovType')),
      expression: "errors.has('fovType')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please Select " + _vm._s(_vm.insuranceapplicablecharge) + " % Type ")]), _vm._v(" "), (_vm.fovType == 'SLAB') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Slab")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('treeselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "clearable": false,
      "name": "selectedSlab",
      "multiple": false,
      "max-height": 200,
      "options": _vm.slabList,
      "placeholder": "Select Slab",
      "append-to-body": true,
      "disabled": false
    },
    on: {
      "select": _vm.selectSlab
    },
    model: {
      value: (_vm.selectedSlab.id),
      callback: function($$v) {
        _vm.selectedSlab.id = $$v
      },
      expression: "selectedSlab.id"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('selectedSlab')),
      expression: "errors.has('selectedSlab')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please select a slab")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("From")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("To")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.insuranceapplicablecharge) + "%")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.selectedSlabListArray), function(slabObj, index) {
    return _c('tr', {
      key: index,
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', {
      staticStyle: {
        "width": "33%"
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('label', [_vm._v(_vm._s(slabObj.from))])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "33%"
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('label', [_vm._v(_vm._s(slabObj.to))])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "33%"
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (slabObj.fovpercentage),
        expression: "slabObj.fovpercentage"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('min_value:0|max_value:100', 'required'),
        expression: "'min_value:0|max_value:100', 'required'"
      }],
      staticClass: "table-input",
      class: {
        'form-control': true,
        'error': _vm.errors.has(("slabvalue" + index))
      },
      staticStyle: {
        "width": "24%",
        "margin-top": "-17px"
      },
      attrs: {
        "type": "number",
        "name": 'slabvalue' + index
      },
      domProps: {
        "value": (slabObj.fovpercentage)
      },
      on: {
        "keypress": function($event) {
          _vm.isNumber($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          slabObj.fovpercentage = $event.target.value
        }
      }
    })])])])
  }))])])])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_c('strong', [_vm._v("Limits (" + _vm._s(_vm.insuranceapplicablecharge) + " Charges) (INR)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("MIN")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.minfovchargelimit && _vm.maxfovchargelimit ? 'min_value:' + _vm.minfovchargelimit + '|max_value:' + _vm.maxfovchargelimit : 'required'),
      expression: "minfovchargelimit && maxfovchargelimit ? 'min_value:'+minfovchargelimit+'|max_value:'+maxfovchargelimit : 'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.minfovchargelimit),
      expression: "minfovchargelimit"
    }],
    class: {
      'number-validation': true,
      'form-control': true,
      'error': _vm.errors.has('Min FOV Charge Limit')
    },
    attrs: {
      "type": "number",
      "name": "Min FOV Charge Limit",
      "id": "minfovchargelimit",
      "placeholder": "MIN"
    },
    domProps: {
      "value": (_vm.minfovchargelimit)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.minfovchargelimit = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Min FOV Charge Limit')),
      expression: "errors.has('Min FOV Charge Limit')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('Min FOV Charge Limit')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("MAX")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.minfovchargelimit && _vm.maxfovchargelimit ? 'min_value:' + _vm.minfovchargelimit + '|max_value:' + _vm.maxfovchargelimit : ''),
      expression: "minfovchargelimit && maxfovchargelimit ? 'min_value:'+minfovchargelimit+'|max_value:'+maxfovchargelimit :''"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.maxfovchargelimit),
      expression: "maxfovchargelimit"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Max FOV Charge Limit')
    },
    attrs: {
      "type": "number",
      "name": "Max FOV Charge Limit",
      "id": "maxfovchargelimit",
      "placeholder": "MAX"
    },
    domProps: {
      "value": (_vm.maxfovchargelimit)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.maxfovchargelimit = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Max FOV Charge Limit')),
      expression: "errors.has('Max FOV Charge Limit')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('Max FOV Charge Limit')))])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.insuranceChargeType == 'FLAT_CHARGE') ? _c('div', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.insuranceapplicablecharge) + " Charge Per Shipment (INR)")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min_value:0'),
      expression: "'min_value:0'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.fovChargePerShipment),
      expression: "fovChargePerShipment"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('FOV Charge Per Shipment')
    },
    attrs: {
      "type": "number",
      "name": "FOV Charge Per Shipment",
      "id": "fovChargePerShipment",
      "placeholder": "Per Shipment Charge"
    },
    domProps: {
      "value": (_vm.fovChargePerShipment)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fovChargePerShipment = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('FOV Charge Per Shipment')),
      expression: "errors.has('FOV Charge Per Shipment')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('FOV Charge Per Shipment')))])], 1)])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveInsuranceCharges('save')
      }
    }
  }, [_vm._v("Save "), _c('i', {
    staticClass: "fa fa-save"
  })])]), _vm._v("  \n    "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "-btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveInsuranceCharges('saveAndNext')
      }
    }
  }, [_vm._v("Save and Next "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])])]), _vm._v(" "), _c('br')])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7b0fa76","hasScoped":true}!./src/modules/masterdata/views/ratetemplate/createratetemplate/insurancecharges/insurancecharges.component.html
// module id = 649
// module chunks = 3